import { ScrollCarousel } from 'Storybook/components/local/ScrollCarousel';

import { GuideCollectionProps } from '../Guides.types';

import { Guide } from './Guide';

type Props = GuideCollectionProps

export const GuideCarousel = ({ className, guides, onGuideClick, setGuideRef }:Props) => (
  <ScrollCarousel
    as='ol'
    className={className}
    data-testid='guideCarousel'
    gap={16}
    label='Guides'
  >
    {guides.map((guide, index) => (
      <Guide
        key={guide.id}
        ref={(ref) => ref && setGuideRef?.(ref, index)}
        onClick={() => {
          onGuideClick?.(guide);
        }}
        {...{ guide }} />
    ))}
  </ScrollCarousel>
);
